
import {URL_API_WEB_FORM_CREATE, URL_API_WEB_FORM_MAP, URL_API_WEB_FORM_EXISTING_CHECK,URL_API_WEB_FORM_UPDATE,
  URL_API_WEB_FORM_UNMAPPED_LIST, URL_API_WEB_FORM_MAPPED_LIST, URL_API_WEB_FORM_NAMES, URL_API_WEB_FORM_NAMES_MAPPED,
  URL_API_WEB_FORM_VIEW_REPORT, URL_API_WEB_FORM_REPORT_SUBMIT, URL_API_WEB_FORM_REPORT_SEARCH} from '../apiHitFile';
import _ from 'lodash';
// create add templates
export function WebFormTemplateAdd(obj){
  return (dispatch, getState) => { 
    let headers = new Headers()    
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_CREATE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
     .then(json =>{ 
      if(json.status === 200){
        dispatch(WebFormTemplateAddSuccess(json))
        dispatch(WebFormTemplate())
      } else {
        dispatch(WebFormError(json))
      }
      })
     .catch((error) => dispatch(WebFormError(error))) 
    }   
}
export function WebFormTemplateAddSuccess(json){
  return{
    type: 'WEB_FORM_TEMPLATES_ADD',
    showerror:true,
    errmessage:json.message
   }
}

////map template
export function WebFormTemplateMap(obj, data) { 
  return  (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_MAP, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
     .then(json => {dispatch(WebFormTemplateMapSuccess(json))
        if(!_.isEmpty(data)) {     
          dispatch(WebFormMappedTemplate(data))
        }
     })
      .catch((error) => dispatch(WebFormError(error)))
    }   
}
export function WebFormTemplateMapSuccess(json){
  return{
    type:"MAPPING_SUCCESS",
    mapCheck:false,
    showerror:true,
    errmessage:json.message
  }
}
export function WebFormTemplateMapExistingCheck(obj){
  return (dispatch, getState)  => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_EXISTING_CHECK, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
      .then(json => {dispatch(WebFormTemplateMapExistingCheckSuccess(json))     
      })
      .catch((error) => dispatch(WebFormError(error)))
    }   
}
export function WebFormTemplateMapExistingCheckSuccess(data){
  return{
    type: 'WEB_FORM_TEMPLATES_EXISTING_CHECK',
    isExisting: data,
    mapCheck:true
   } 
}
export function resetMapCheck(){
  return{
    type:"RESET_MAP_CHECK",
    mapCheck:false
  }
}

//edit 
export function WebFormTemplateEdit(obj){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_UPDATE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())  
     .then(json =>{
      if(json.status === 200){
        dispatch(WebFormTemplate(obj))
        dispatch({type:"WEB_FORM_ERROR", showerror: true, errmessage: json.message})
      } else {
        dispatch(WebFormError(json))
      }
     })
     .catch((error) => dispatch(WebFormError(error)))
    }     
}
export function WebFormTemplateEditSuccess(obj){
  return{
    type: 'WEB_FORM_TEMPLATES_EDIT',
    obj
   }
}
//list unmapped templates
export function WebFormTemplate(){
  return (dispatch, getState) => {
    dispatch(WebFormTemplatePending());
    let headers = new Headers()
    fetch(URL_API_WEB_FORM_UNMAPPED_LIST,{
      method: 'GET',
      headers : headers,
    })
     .then(res=>res.json())
     .then(json => dispatch(WebFormTemplateSuceess(json)))
     .catch((error) => console.log(error))
    }
}
export function WebFormTemplatePending(){
  return{
    type: 'WEB_FORM_TEMPLATES_PENDING',
  }
}
export function WebFormTemplateSuceess(templates){
  return{
    type: 'WEB_FORM_TEMPLATES',
    payload: templates.value
  }  
}

// list mapped templates //
export function WebFormMappedTemplate(obj){ 
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(ISPENDING())
    fetch(URL_API_WEB_FORM_MAPPED_LIST,{
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    })
     .then(res=>res.json())
     .then(json => dispatch(WebFormMappedSuceess(json)))
     .catch((error) => console.log(error))     
    }   
} 
export function ISPENDING(){
  return{
    type: 'IS_PENDING',
    isPending:true
  }  
}


export function WebFormMappedSuceess(mappedTemplate){
  return{
    type: 'WEB_FORM_TEMPLATES_MAPPED',
    mappedData: mappedTemplate.value,
    isPending:false
  }  
}
 
//list form names
export function WebFormTemplateNames(){
  return (dispatch, getState) => {
    let headers = new Headers()
    fetch(URL_API_WEB_FORM_NAMES, {
      method: 'GET',
      headers : headers,
    })
     .then(res=>res.json())
     .then(json => dispatch(WebFormTemplateNamesSuceess(json)))
     .catch((error) => console.log(error)) 
    }
}


export function WebFormTemplateNamesSuceess(templatename){
  return{
    type: 'WEB_FORM_TEMPLATES_NAMES',
    formName: templatename.value
  }  
}

export function WebFormTemplateMappedNames(userName){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_NAMES_MAPPED, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(userName)
    })
     .then(res=>res.json())
     .then(json => dispatch(WebFormTemplateMappedNamesSuceess(json)))
     .catch((error) => console.log(error)) 
    }
}


export function WebFormTemplateMappedNamesSuceess(templatename){
  return{
    type: 'WEB_FORM_TEMPLATES_NAMES_MAPPED',
    formNameMapped: templatename.value
  }  
}
// View Reportn
export function WebFormViewReport(obj){
  return  (dispatch, getState)  => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_VIEW_REPORT,  {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then(res=>res.json())
     .then((json) => { dispatch(WebFormViewReportSuccess(json)) })
     .catch((error) => { dispatch(WebFormError(error)) })
    }
}
export function WebFormViewReportSuccess(output){
  if(output.status===200){
  return{
    type: 'WEB_FORM_TEMPLATES_VIEW_REPORT',
    report: output.value
   } 
  } else {
    return{
      type:"WEB_FORM_ERROR",
      showerror: true,
      errmessage: output.error
    }
  }
}
// View Report Submit
export function WebFormViewReportSubmit(Object){ 
  return (dispatch, getState)  => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_REPORT_SUBMIT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(Object)
    }).then((res) => res.json())
      .then(json => dispatch({
        type:"WEB_FORM_ERROR",
        showerror: true,
        errmessage: json.message
      }))
      .catch((err)=> dispatch(WebFormError(err))) 
    }   
}

export function WebFormSearchCompleted(prop){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WEB_FORM_REPORT_SEARCH, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())
      .then(json => dispatch(WebFormSearchCompletedSuccess(json))) 
      .catch(error => dispatch(WebFormError(error)))
     // .catch(error => dispatch(WebFormSearchCompletedSuccess(error)))
     }
}
export function WebFormSearchCompletedSuccess(data){
  if(data.status === 200){
  return {
    type: "WEB_FORM_SEARCH",    
    searchReport:data.value
    }
  } else {
    return{
      type:"WEB_FORM_ERROR",
      showerror: true,
      errmessage: data.error
    }
  }
}
export function resetsearchData(){
  return {
    type: "WEB_FORM_SEARCH",    
    searchReport:[]
    }
}
export function WebFormError(data){  
  return{
    type:"WEB_FORM_ERROR",
    showerror: true,
    errmessage: data.error
  }
}
export function closeModalPopUp(){
  return{
    type:'WEB_FORM_MODAL_CLOSE',
    showerror:false
  }

}
